import {
  KeyboardEvent,
  MouseEvent,
  ReactNode,
  useCallback,
  useState,
} from 'react';
import {
  TPanelEvent,
  TPanelIdentifier,
  eventsController,
  usePanelOnEvent,
} from '../../../eventsController';
import { TFooter } from '../../../actions/usePanelActions';
import { handleAction } from '../../../actions/basicAction';
import { usePanelIdentity } from '../../../common';

export function changePanelFooter(panelId: string, footer: TFooter | null) {
  eventsController.fireEvent(
    { panelId } as TPanelIdentifier,
    'changeFooter',
    footer,
  );
}

export type TUsePanelFooter = {
  footerContent?: ReactNode;
  footer: TFooter | null;
  handleFooterClick: (ev: MouseEvent | KeyboardEvent) => void;
};

export function usePanelFooter({
  initialData,
}: {
  initialData: unknown;
}): TUsePanelFooter {
  const identifier = usePanelIdentity();

  const [footer, setFooter] = useState<TFooter | null>(
    (initialData as { footer: { footer: TFooter } })?.footer?.footer?.text ||
      (initialData as { footer: { footer: TFooter } })?.footer?.footer?.force
      ? (initialData as { footer: { footer: TFooter } })?.footer?.footer
      : null,
  );

  const handleFooterClick = useCallback(
    (ev: MouseEvent | KeyboardEvent) => {
      if (footer) handleAction(identifier, ev, footer);
    },
    [footer, identifier],
  );

  usePanelOnEvent(
    { eventType: 'changeFooter', panelId: identifier.panelId },
    (ev: TPanelEvent<TFooter>) => {
      if (!ev.payload.text && !ev.payload.force) setFooter(null);
      else setFooter(ev.payload);
    },
  );

  return { footer, handleFooterClick };
}
